import { createContext, useContext, type ElementType } from "react";

interface FormGeneratorContextValue {
  componentMap: Record<string, ElementType>;
}

const FormGeneratorContext = createContext<
  FormGeneratorContextValue | undefined
>(undefined);

export const FormGeneratorProvider = FormGeneratorContext.Provider;

export const useFormGeneratorContext = (): FormGeneratorContextValue => {
  const context = useContext(FormGeneratorContext);

  if (context === undefined) {
    throw new Error(
      "useFormGeneratorContext must be used within FormGeneratorProvider",
    );
  }

  return context;
};
